import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import momentTz from "moment-timezone";
import { setMonth } from "./../../Slices/candidateSlice.js";
import { useLocation, useNavigate } from "react-router-dom";

function MonthPicker(props) {
  const { month, onMonthChange, fGettingUsedInOrgDashboard=false } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  
  // Get timezone from Redux state
  const { sessionUser: { timezone } } = useSelector((state) => state.sessionSlice);
  
  //#region Store Listeners
  //#endregion

  const nextMonth = () => {
    // Use timezone-aware moment calculations
    const currentMonth = momentTz(month).tz(timezone);
    const nextMonth = currentMonth.clone().add(1, 'month');

    // If onMonthChange callback is provided, use it instead of Redux dispatch
    if (onMonthChange) {
      onMonthChange(nextMonth.toISOString());
    } else {
      dispatch(
        setMonth({ month: nextMonth.toISOString(), monthChangedTo: "next" })
      );
    }
    if (pathname.includes('candidateScreenshots')) { 
    // Keep URL query param `d` in sync with the first day of the new month
    const date = nextMonth.clone().startOf("month").format('YYYY-MM-DD');
      const params = new URLSearchParams(search);
      params.set('date', date);
      navigate(`${pathname}?${params.toString()}`, { replace: true });
    }
  };

  const prevMonth = () => {
    // Use timezone-aware moment calculations
    const currentMonth = momentTz(month).tz(timezone);
    const prevMonth = currentMonth.clone().subtract(1, 'month');

    // If onMonthChange callback is provided, use it instead of Redux dispatch
    if (onMonthChange) {
      onMonthChange(prevMonth.toISOString());
    } else {
      dispatch(
        setMonth({ month: prevMonth.toISOString(), monthChangedTo: "prev" })
      );
    }
    if (pathname.includes('candidateScreenshots')) { 
      // Keep URL query param `d` in sync with the first day of the new month
      const date = prevMonth.clone().startOf("month").format('YYYY-MM-DD');
      const params = new URLSearchParams(search);
      params.set('date', date);
      navigate(`${pathname}?${params.toString()}`, { replace: true });
    }
  };

  return (
    <Container style={fGettingUsedInOrgDashboard ? { padding: 0 } : undefined}>
      <Row>
        <Col sm="2" style={fGettingUsedInOrgDashboard ? { padding: 0, marginTop: 5 } : undefined}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="black"
            className="bi bi-chevron-left"
            viewBox="0 0 16 16"
            style={{ cursor: "pointer" }}
            onClick={() => {
              prevMonth();
            }}
          >
            <path
              fillRule="evenodd"
              d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
            />
          </svg>
        </Col>
        <Col className="text-center" style={fGettingUsedInOrgDashboard ? { padding: 0, marginTop: 6 } : undefined}>
          <span>{momentTz(month).tz(timezone).format("MMM")}</span>
          <span>{" " + momentTz(month).tz(timezone).year()}</span>
        </Col>
        <Col sm="2" style={fGettingUsedInOrgDashboard ? { padding: 0, marginTop: 5 } : undefined}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="black"
            className="bi bi-chevron-right"
            viewBox="0 0 16 16"
            style={{ cursor: "pointer" }}
            onClick={() => {
              nextMonth();
            }}
          >
            <path
              fillRule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </Col>
      </Row>
    </Container>
  );
}

MonthPicker.propTypes = {
  month: PropTypes.string.isRequired,
  onMonthChange: PropTypes.func,
  fGettingUsedInOrgDashboard: PropTypes.bool,
};

export default MonthPicker;
